import React from 'react';
// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';
// import { DateRangePicker } from 'react-dates';

export default ({ id, onDatesChange, ...props }) => (
  <div>https://github.com/react-dates/react-dates/issues/2105</div>
);
